import Text from '@components/common/text';
import { useJobGroupsWithTitles } from '@repository/codes/useCodes';
import PassReviewPostGetRs from '@domain/rs/passReview/PassReviewPostGetRs';
import { FontStyle } from '@domain/constant/fontStyle';
import Colors from '@domain/constant/colors';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface Props {
  reviewData: PassReviewPostGetRs;
}

const Review = ({ reviewData }: Props) => {
  const { data: jobGroupsWithTitles } = useJobGroupsWithTitles();

  if (!reviewData) return null;
  const selectedJobGroup = jobGroupsWithTitles?.find((jobGroup) => jobGroup.code === reviewData.jobGroupCode);
  const selectedJobTitle = selectedJobGroup?.jobTitles.find((jobTitle) => jobTitle.code === reviewData.jobTitleCode);

  return (
    <div className={cx('banner')}>
      <div>
        <Text fontStyle={FontStyle.H4_B}>합격을 축하합니다.</Text>
        <Text
          fontStyle={FontStyle.B2P_B}
          color={Colors.C_COOL_GRAY_70}
          styles={{ display: 'flex', alignItems: 'center', marginTop: '16px' }}
        >
          <span>기업</span>
          <div className={cx('divider')} />
          <span className={cx('label')}> {reviewData.companyName}</span>
        </Text>
        <Text
          fontStyle={FontStyle.B2P_B}
          color={Colors.C_COOL_GRAY_70}
          styles={{ display: 'flex', alignItems: 'center' }}
        >
          <span>직군</span>
          <div className={cx('divider')} />
          <span className={cx('label')}> {selectedJobGroup?.name}</span>
        </Text>
        <Text
          fontStyle={FontStyle.B2P_B}
          color={Colors.C_COOL_GRAY_70}
          styles={{ display: 'flex', alignItems: 'center' }}
        >
          <span>직무</span>
          <div className={cx('divider')} />
          <span className={cx('label')}> {selectedJobTitle?.name}</span>
        </Text>
      </div>
      <img
        src={'/img/v2/components/passboard/banner.png'}
        alt="img"
        width={280}
        height={280}
        style={{ objectFit: 'cover' }}
      />
    </div>
  );
};

export default Review;
